import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import * as AppIconModule from './re-joy/AppIcon';
import { navLinks } from '../data/navLinks';

// Guard against the design-system bundle failing to resolve, so the header never crashes.
const BrandIcon = (AppIconModule as {
  AppIcon?: React.ComponentType<{
    size?: number;
    mode?: 'light' | 'dark';
    bare?: boolean;
  }>;
}).AppIcon;
interface NavbarProps {
  onOpenWaitlist: () => void;
}
export const Navbar: React.FC<NavbarProps> = ({
  onOpenWaitlist
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 8);
    handleScroll();
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    if (!isMenuOpen) return;
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setIsMenuOpen(false);
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [isMenuOpen]);
  const handleJoin = () => {
    setIsMenuOpen(false);
    onOpenWaitlist();
  };
  const isSolid = isScrolled || isMenuOpen;
  return <header className={`fixed top-0 left-0 right-0 z-40 transition-[background-color,box-shadow] duration-300 ${isSolid ? 'bg-white shadow-[0_1px_0_rgba(174,207,193,0.6)]' : 'bg-white/0'}`} data-id="element-147" data-mp="okp0kb4kg11i">
      <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:rounded-lg focus:bg-white focus:px-4 focus:py-2 focus:text-deep-juniper" data-id="element-148" data-mp="3s0cl4xllh3uo">
        Skip to content
      </a>
      <div className="section-container" data-id="element-149" data-mp="34do1o7gxt3by">
        <div className="flex h-20 items-center justify-between gap-6" data-id="element-150" data-mp="34as4wmgtskp3">
          <a href="#top" className="flex items-center gap-2.5 rounded-md font-literata text-3xl font-medium text-deep-juniper" aria-label="Re:Joy home" data-id="element-151" data-mp="39ao7qidse632">
            {BrandIcon && <BrandIcon size={40} mode="light" bare data-id="element-152" data-mp="2wbwvwzhz86k3" />}
            <span data-id="element-153" data-mp="3b1m9xvb6451s">
              Re:<span className="text-rejoy-coral" data-id="element-154" data-mp="3b01johvvz89q">Joy</span>
            </span>
          </a>

          <nav aria-label="Primary" className="hidden lg:block" data-id="element-155" data-mp="3631avz7njrex">
            <ul className="flex items-center gap-8" data-id="element-156" data-mp="2icfbewbprfgj">
              {navLinks.map(link => <li key={link.href} data-id="element-157" data-mp="2ddc9vluxzrdb">
                  <a href={link.href} className="nav-link" data-id="element-158" data-mp="2deduoi1rfs88">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </nav>

          <div className="hidden lg:block" data-id="element-159" data-mp="2nayyx15ygzb0">
            <button type="button" onClick={onOpenWaitlist} className="btn-primary" data-id="element-160" data-mp="2na76u0bkhjph">
              Join the waitlist
            </button>
          </div>

          <button type="button" onClick={() => setIsMenuOpen(open => !open)} className="lg:hidden -mr-2 rounded-lg p-2 text-deep-juniper" aria-expanded={isMenuOpen} aria-controls="mobile-menu" aria-label={isMenuOpen ? 'Close menu' : 'Open menu'} data-id="element-161" data-mp="2lsy3trs7hr2">
            {isMenuOpen ? <XIcon size={24} data-id="element-162" data-mp="15x688xcd909" /> : <MenuIcon size={24} data-id="element-163" data-mp="16gmzmb99rcp" />}
          </button>
        </div>
      </div>

      {isMenuOpen && <div id="mobile-menu" className="lg:hidden border-t border-mist-sage/60 bg-white" data-id="element-164" data-mp="sva2fhtu30l8">
          <nav aria-label="Mobile" className="section-container py-4" data-id="element-165" data-mp="xuwevp1u8csz">
            <ul className="flex flex-col" data-id="element-166" data-mp="xw7jfr33xol5">
              {navLinks.map(link => <li key={link.href} data-id="element-167" data-mp="k0vopjoyby48">
                  <a href={link.href} onClick={() => setIsMenuOpen(false)} className="block rounded-md py-3 text-lg text-ink-text hover:text-deep-juniper" data-id="element-168" data-mp="o41s8jkojb70">
                    {link.label}
                  </a>
                </li>)}
            </ul>
            <button type="button" onClick={handleJoin} className="btn-primary mt-4 w-full" data-id="element-169" data-mp="3p3i7qvcp0b81">
              Join the waitlist
            </button>
          </nav>
        </div>}
    </header>;
};